/* Progressive motion: content is visible even if JavaScript or animation support fails. */
(() => {
  if (window.vapPolishLoaded) return;
  window.vapPolishLoaded = true;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const imageSelector = '.ve-hero__visual img,.ve-category__image img,.ve-banner>img,img.msv-card__img,.product__media img,.ve-brand__image img,.ve-review img,.vap-real-space img,.ve-advice__visual img,.ve-about-image img,.ve-prose img';
  const seenImages = new WeakSet();
  const seenStats = new WeakSet();
  const tickers = new Map();
  const running = new Set();
  const countFrames = new Map();
  function showImage(img) {
    if (preference.matches || !img.isConnected || typeof img.animate !== 'function') return;
    const reveal = () => {
      if (preference.matches || !img.isConnected || !img.getClientRects().length) return;
      const motion = img.animate([{opacity:.8,transform:'scale(1.018)'},{opacity:1,transform:'scale(1)'}], {duration:650,easing:'cubic-bezier(.22,.61,.36,1)'});
      running.add(motion);
      motion.addEventListener('finish', () => running.delete(motion), {once:true});
      motion.addEventListener('cancel', () => running.delete(motion), {once:true});
    };
    if (img.complete) reveal(); else img.addEventListener('load', reveal, {once:true});
  }
  const finalNumber = el => Number(el.dataset.vapCount).toLocaleString('es-AR',{minimumFractionDigits:Number(el.dataset.decimals || 0),maximumFractionDigits:Number(el.dataset.decimals || 0)});
  function finishNumber(el) {cancelAnimationFrame(countFrames.get(el));countFrames.delete(el);el.textContent=finalNumber(el);}
  function count(section) {
    section.querySelectorAll('[data-vap-count]').forEach(el => {
      if (preference.matches) return finishNumber(el);
      const target=Number(el.dataset.vapCount), decimals=Number(el.dataset.decimals || 0);
      let start;
      function frame(time) {
        if (!el.isConnected || preference.matches) return finishNumber(el);
        start ??= time;
        const progress=Math.min(1,(time-start)/1000);
        const value=target*(1-Math.pow(1-progress,3));
        el.textContent=value.toLocaleString('es-AR',{minimumFractionDigits:decimals,maximumFractionDigits:decimals});
        if (progress<1) countFrames.set(el,requestAnimationFrame(frame)); else finishNumber(el);
      }
      countFrames.set(el,requestAnimationFrame(frame));
    });
  }
  const imageObserver='IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    imageObserver.unobserve(entry.target);showImage(entry.target);
  }),{threshold:.12}) : null;
  const statsObserver='IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    statsObserver.unobserve(entry.target);count(entry.target);
  }),{threshold:.2}) : null;
  function init(root=document) {
    root.querySelectorAll(imageSelector).forEach(img => {
      if (seenImages.has(img)) return;seenImages.add(img);
      if (!preference.matches) imageObserver?.observe(img);
    });
    root.querySelectorAll('[data-vap-stats]').forEach(section => {
      if (seenStats.has(section)) return;seenStats.add(section);
      if (!preference.matches) {if(statsObserver)statsObserver.observe(section);else count(section);}
    });
    root.querySelectorAll('[data-vap-ticker]').forEach(ticker => {
      if (tickers.has(ticker)) return;
      const button=ticker.querySelector('[data-vap-ticker-pause]');
      if (!button) return;
      const click=() => {
        const paused=ticker.classList.toggle('is-paused');
        button.setAttribute('aria-pressed',String(paused));
        button.setAttribute('aria-label',paused?'Reanudar aviso en movimiento':'Pausar aviso en movimiento');
      };
      button.addEventListener('click',click);
      tickers.set(ticker,() => button.removeEventListener('click',click));
      ticker.classList.toggle('is-animated',!preference.matches);button.hidden=preference.matches;
    });
  }
  function updatePreference() {
    tickers.forEach((cleanup,ticker) => {ticker.classList.toggle('is-animated',!preference.matches);ticker.querySelector('[data-vap-ticker-pause]').hidden=preference.matches;});
    if (preference.matches) {
      running.forEach(animation => animation.cancel());running.clear();
      imageObserver?.disconnect();statsObserver?.disconnect();
      document.querySelectorAll('[data-vap-count]').forEach(finishNumber);
    }
  }
  preference.addEventListener?.('change',updatePreference);
  const visibility=() => document.documentElement.classList.toggle('vap-document-hidden',document.hidden);
  document.addEventListener('visibilitychange',visibility);visibility();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',() => init(),{once:true});else init();
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => {
    event.target.querySelectorAll(imageSelector).forEach(img => {imageObserver?.unobserve(img);seenImages.delete(img);});
    event.target.querySelectorAll('[data-vap-stats]').forEach(section => {statsObserver?.unobserve(section);seenStats.delete(section);});
    event.target.querySelectorAll('[data-vap-count]').forEach(finishNumber);
    event.target.querySelectorAll('[data-vap-ticker]').forEach(ticker => {tickers.get(ticker)?.();tickers.delete(ticker);});
  });
})();
